<h2 mat-dialog-title *ngIf = "product['product']">
  <span *ngIf="product['isLastProduct'] && loggedIn && !!this.selectedDeliveryCalendar; else matTitle">
    Cancel the Order
  </span>
  <ng-template #matTitle>
    <span>Delete Product from Order</span>
  </ng-template>
</h2>
<mat-dialog-content class="mat-typography"  *ngIf="product['product']">
  <span *ngIf="product['isLastProduct'] && loggedIn && !!this.selectedDeliveryCalendar; else matContent">
    Deleting this product will cancel your order for
    {{selectedDeliveryCalendar['delivery_date'] |  storeBasedDate: false: 'dd': 'MM': 'yyyy': '/'}}.
    Are you sure you want to proceed?
  </span>
  <ng-template #matContent>
    <p>Are you sure you want to delete this item from Sale Order?</p>
  </ng-template>
</mat-dialog-content>
<mat-dialog-actions  *ngIf = "product['product']" fxLayoutAlign ="end" class="pb-24px">
  <mat-spinner-button [options]="deleteCartButtonOptions" mat-button 
    (click) = "delete('single')" color = "warn">
    {{ product['isLastProduct'] && loggedIn && !!this.selectedDeliveryCalendar ? 'Yes' : 'Delete' }}
  </mat-spinner-button>
  <button mat-button mat-dialog-close = "cancel" color = "primary">
    {{ product['isLastProduct'] && loggedIn && !!this.selectedDeliveryCalendar ? 'No' : 'Cancel' }}
  </button>
</mat-dialog-actions>
<h2 mat-dialog-title *ngIf = "product['value']">Delete All products from Cart</h2>
<mat-dialog-content class="mat-typography"  *ngIf = "product['value']">
 <p>Are you sure you want to clear Cart?</p>
</mat-dialog-content>
<mat-dialog-actions  *ngIf = "product['value']" fxLayoutAlign ="end" class="pb-24px">
  <button mat-button (click) = "delete('all')" color = "warn">Delete All</button>
  <button mat-button mat-dialog-close = "cancel" color = "primary">Cancel</button>
</mat-dialog-actions>